import { render, staticRenderFns } from "./registerPart.vue?vue&type=template&id=224284d0&scoped=true"
import script from "./registerPart.vue?vue&type=script&lang=js"
export * from "./registerPart.vue?vue&type=script&lang=js"
import style0 from "./registerPart.vue?vue&type=style&index=0&id=224284d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224284d0",
  null
  
)

export default component.exports